// extracted by mini-css-extract-plugin
module.exports = {"spinIcon":"CtaButton_spinIcon__sIIRQ","spin":"CtaButton_spin__iTr1W"};